<template>
  <div v-if="show" class="popup guide" @click="closePopup">
    <div class="popup-container">
      <div class="popup-header">
        <h2 v-text="$t('device_setting.device_add_guide')"></h2>
        <button class="icon close" @click.stop="show = false"></button>
      </div>
      <div class="popup-body">
        <!-- 가이드 이미지 들어갈 곳 -->
        <span class="guide_text" v-text="'STEP 1.'"></span>
        {{ $t('popup_guide.step1_title') }}
        <div class="qrcode_container">
          <div class="qrcode_item">
            <img src="@assets/images/qrcode_aos.png" alt="AOS QRCODE" />
            <label>AOS</label>
          </div>
          <div class="qrcode_item">
            <img :src="iosQrcode" alt="iOS QRCODE" />
            <label>iOS</label>
          </div>
        </div>
        <span class="guide_text" v-text="'STEP 2.'"></span>
        {{ $t('popup_guide.step2_title') }}
        <div v-for="image in guideImage" :key="image" class="guide_image">
          <img :src="image" alt="" width="100%" height="auto" />
        </div>
      </div>
      <div class="popup-footer">
        <div class="button-box">
          <button
            class="button primary"
            @click.stop="show = false"
            v-text="$t('confirm')"
          ></button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie';
import { Common } from '@src/common';
import qrcodeIOSKo from '@assets/images/qrcode-ios-ko.png';
import qrcodeIOSJa from '@assets/images/qrcode-ios-ja.png';
import qrcodeIOSEn from '@assets/images/qrcode-ios-en.png';
import guideImageKo1 from '@assets/images/guide-ko-1.png';
import guideImageKo2 from '@assets/images/guide-ko-2.png';
import guideImageKo3 from '@assets/images/guide-ko-3.png';
import guideImageKo4 from '@assets/images/guide-ko-4.png';
import guideImageJa1 from '@assets/images/guide-ja-1.png';
import guideImageJa2 from '@assets/images/guide-ja-2.png';
import guideImageJa3 from '@assets/images/guide-ja-3.png';
import guideImageJa4 from '@assets/images/guide-ja-4.png';
import guideImageEn1 from '@assets/images/guide-en-1.png';
import guideImageEn2 from '@assets/images/guide-en-2.png';
import guideImageEn3 from '@assets/images/guide-en-3.png';
import guideImageEn4 from '@assets/images/guide-en-4.png';

export default {
  name: 'PopupGuide',
  props: {
    opened: false,
  },
  computed: {
    show: {
      get() {
        return this.opened;
      },
      set(value) {
        if (!value) {
          this.$emit('popupOff');
        }
      },
    },
  },
  data() {
    return {
      iosQrcode: qrcodeIOSKo,
      guideImage: [],
    };
  },
  created() {
    const lang = Cookies.get(Common.STORAGE_LANG);

    if (lang === Common.CONST_LANG_KO) {
      this.iosQrcode = qrcodeIOSKo;
      this.guideImage = [
        guideImageKo1,
        guideImageKo2,
        guideImageKo3,
        guideImageKo4,
      ];
    } else if (lang === Common.CONST_LANG_JA) {
      this.iosQrcode = qrcodeIOSJa;
      this.guideImage = [
        guideImageJa1,
        guideImageJa2,
        guideImageJa3,
        guideImageJa4,
      ];
    } else {
      this.iosQrcode = qrcodeIOSEn;
      this.guideImage = [
        guideImageEn1,
        guideImageEn2,
        guideImageEn3,
        guideImageEn4,
      ];
    }
  },
  methods: {
    closePopup(e) {
      this.show = e.target.className !== 'popup guide';
    },
  },
};
</script>

<style scoped lang="scss">
.popup {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;

  .popup-container {
    background-color: $white;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;

    .popup-header {
      width: 100%;
      height: 56px;
      padding: 0 16px;
      border-bottom: 1px solid $gray-eb;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      h2 {
        font-size: 14px;
        color: $gray-33;
      }

      .icon.close {
        width: 15px;
        height: 15px;
        margin: auto 0;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 16px;
        background-image: url(~@assets/images/icon-close.png);
        background-color: transparent;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100%;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        border-radius: 10px;
      }
    }

    .popup-body {
      width: 100%;
      padding: 25px;
      font-size: 13px;
      overflow-y: scroll;
    }

    .popup-footer {
      width: 100%;
      height: 88px;

      .button-box {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .button {
          width: 56px;
          height: 28px;
          padding: 0;
          font-size: 11px;
          -webkit-border-radius: 16px;
          -moz-border-radius: 16px;
          border-radius: 16px;
        }

        .button + .button {
          margin-left: 24px;
        }
      }
    }
  }

  .guide_text {
    font-size: 13px;
    font-weight: bold;
    color: $primary;
    line-height: 250%;
  }

  .guide_image {
    margin-top: 20px;
    margin-bottom: 40px;
  }

  .qrcode_container {
    display: flex;

    .qrcode_item {
      align-items: flex-start;
      text-align: center;
      width: 50%;

      label {
        display: block;
        font-size: 15px;
        padding: 5px 0px;
      }

      img {
        width: 100px;
      }
    }
  }

  &.guide {
    .popup-container {
      min-width: 800px;
      width: 75%;
      height: 80%;
      min-height: 600px;

      .popup-body {
        height: calc(100% - 144px);
      }
    }
  }
}
</style>
